"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTravelerDOB = exports.validateAdultTravelerDOB = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
const DOBInput_utils_1 = require("./DOBInput.utils");
const MIN_ADULT_AGE = 16;
const validateAdultTravelerDOB = (value) => {
    if (!(0, exports.validateTravelerDOB)(value))
        return false;
    const dob = (0, DOBInput_utils_1.parseDateInputValue)(value || '');
    if (!dob)
        return false;
    return !DOBInput_utils_1.validators.isUserDateAfterSomeDate(dob, (0, DOBInput_utils_1.getOldestDOB)(MIN_ADULT_AGE));
};
exports.validateAdultTravelerDOB = validateAdultTravelerDOB;
const validateTravelerDOB = (value) => {
    if (!value || /^[_/]+$/.exec(value))
        return true;
    const dob = (0, DOBInput_utils_1.parseDateInputValue)(value || '');
    if (!dob)
        return false;
    if (DOBInput_utils_1.validators.isNotFullyFilled(dob))
        return false;
    if (DOBInput_utils_1.validators.hasBlankParts(dob))
        return false;
    if (DOBInput_utils_1.validators.hasInvalidDateParts(dob))
        return false;
    if (!DOBInput_utils_1.validators.isUserDateExists(dob))
        return false;
    return !DOBInput_utils_1.validators.isUserDateAfterSomeDate(dob, (0, libs_utils_1.getTodaysDate)());
};
exports.validateTravelerDOB = validateTravelerDOB;
//# sourceMappingURL=DOBInput.validation.js.map